import util from '@bmp-vue/core/api/util'

const controller = 'Enum'
export default Object.assign({}, util.GetCrud(controller, ['none']),
  {
    TipoPerfilOperador: {
      Nenhum: 0,
      Administrador: 1,
      Operador: 1 << 1,
      Subparceiro: 1 << 2
    },
    TipoOperadorRetaguarda : {
      nenhum: "Nenhum",
      consulta: "Consulta",
      administrador: "Administrador",
      subparceiro: "Subparceiro"
    },
    TipoResponseContextoCadastros: {
      Sucesso: 0,
      Alerta: 1,
      Erro: 2
    },
    TipoDesconto: {
      Isento: 0,
      ValorFixo: 1,
      PercentualDataInformada: 2,
      ValorAntecipacao: 3,
      PercentualAntecipacao: 5
    }
  }
)
